import axios from 'axios';

const state = {
    loading: true,
    all: [],
    restaurant: null,
    workingHours: null,
    openingHoursToday: null,
    settings: null,
};

const getters = {
    isRestaurantOpen(state) {
        return state.restaurant.enabled;
    },

    restaurantHasOpeningHours(state) {
        return state.restaurant.working_hours.filter(workingHour => workingHour.open === 1).length;
    },
};

const actions = {
    async getRestaurant({ commit }) {
        const { data } = await axios.get('/show');
        commit('setProducts', data.categories);
        commit('setRestaurant', data);
        commit('setWorkingHours', data.working_hours);
        commit('setSettings', data.settings);
        commit('setLoading', false);
    },
};

const mutations = {
    setProducts(state, products) {
        state.all = products;
    },
    setWorkingHours(state, details) {
        state.workingHours = details;
    },
    setOpeningHours(state, details) {
        state.openingHoursToday = details;
    },
    setRestaurant(state, details) {
        state.restaurant = details;
    },
    setSettings(state, details) {
        state.settings = details;
    },
    setLoading(state, boolean) {
        state.loading = boolean;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
